<template>
  <base-widget
    icon="clock-fill"
    class="emp-attendance-status-widget"
    :empty="isEmpty"
    :empty-text="emptyText"
    :loading="isLoading"
    :title="title"
  >
    <div
      v-for="record in recordList"
      :key="record.id"
      class="orangehrm-leave-card"
    >
      <div class="orangehrm-leave-card-profile-image">
        <img
          alt="profile picture"
          class="employee-image"
          :src="`../pim/viewPhoto/empNumber/${record.employee.empNumber}`"
        />
      </div>
      <div class="orangehrm-leave-card-details">
        <oxd-text tag="p" class="orangehrm-leave-card-emp-name">
          {{ record.empName }}
        </oxd-text>
        <oxd-text tag="p" class="orangehrm-leave-card-leave-details">
          {{ record.time }}
        </oxd-text>
      </div>
      <oxd-text tag="p" class="orangehrm-leave-card-emp-id">
        {{ record.employee.employeeId }}
      </oxd-text>
    </div>
  </base-widget>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import {freshDate, formatDate, parseDate} from '@ohrm/core/util/helper/datefns';
import BaseWidget from '@/orangehrmDashboardPlugin/components/BaseWidget.vue';
import useEmployeeNameTranslate from '@/core/util/composable/useEmployeeNameTranslate';
import useLocale from '@/core/util/composable/useLocale';

export default {
  name: 'EmployeeCheckInWidget',

  components: {
    'base-widget': BaseWidget,
  },

  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/dashboard/employees/attendance',
    );
    const {$tEmpName} = useEmployeeNameTranslate();
    const {locale} = useLocale();

    return {
      http,
      tEmpName: $tEmpName,
      locale,
    };
  },

  data() {
    return {
      recordList: [],
      isLoading: false,
    };
  },

  computed: {
    isEmpty() {
      return this.recordList.length === 0;
    },
    title() {
      return 'Employees Check In Today';
    },
    emptyText() {
      return 'No Employees Checked In Today';
    },
  },

  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll({
        date: formatDate(freshDate(), 'yyyy-MM-dd'),
        status: 'PUNCHED IN',
      })
      .then((response) => {
        const {data} = response.data;
        this.recordList = data.map((item) => {
          const {employee, punchInTime} = item;

          let formattedTime = punchInTime;
          if (punchInTime) {
            const dateObj = parseDate(punchInTime, 'yyyy-MM-dd HH:mm:ss');
            formattedTime = formatDate(dateObj, 'hh:mm a', {
              locale: this.locale,
            });
          }

          return {
            id: item.id,
            employee: employee,
            empName: this.tEmpName(employee, {
              includeMiddle: false,
              excludePastEmpTag: false,
            }),
            time: formattedTime,
          };
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style src="./employee-on-leave-widget.scss" lang="scss" scoped></style>
